import React from 'react'

const EmailPreview = () => {
  return <div>Testing</div>
}

export default EmailPreview
